<template>
  <!-- Two sibling layers rather than one wrapper: an animating opacity creates a stacking context and would trap their z-index -->
  <div
    aria-hidden="true"
    class="pointer-events-none absolute inset-0 -z-10 opacity-0 transition-opacity duration-200 [border-radius:inherit] group-hover:opacity-100 [background:radial-gradient(10rem_circle_at_var(--spotlight-x,50%)_var(--spotlight-y,0%),theme(colors.brand.50),transparent_65%)]"
  />

  <!-- Lit edge above the content so it stays visible over a media block: the padding-box mask is excluded, leaving only the 1px border painted -->
  <div
    aria-hidden="true"
    class="pointer-events-none absolute inset-0 z-10 border border-transparent opacity-0 transition-opacity duration-200 [border-radius:inherit] [background:radial-gradient(12rem_circle_at_var(--spotlight-x,50%)_var(--spotlight-y,0%),theme(colors.brand.600),transparent_60%)_border-box] [mask-image:linear-gradient(theme(colors.black),theme(colors.black)),linear-gradient(theme(colors.black),theme(colors.black))] [mask-clip:padding-box,border-box] [mask-composite:exclude] supports-[mask-composite:exclude]:group-hover:opacity-100"
  />
</template>
